import React,{useState, useEffect, useRef, Fragment} from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { officials } from '../../../apis/urls'   
import { $ } from "react-jquery-plugin";
import { Dropdown } from "rsuite";

const AddOfficials = () => {

    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('GA');
    const [zip, setZip] = useState(null);
    const [email, setEmail] = useState('');
    const [wphone, setWhone] = useState('');
    const [hphone, setHphone] = useState('');
    //const [types, setTypes] = useState('');
    const [status, setStatus] = useState('');

    useEffect(()=>{
        $('html,body').animate({ scrollTop: 0 }, 'fast');
    },[])

    const statesData = ["AL","AK","AS","AR","AZ","CA","CO","CT","DE","DC","FM","FL","GA","GU","HI","ID","IL","IN","IA","KS","KY","LA","ME","MH","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PW","PA","PR","RI","SC","SD","TN","TX","UT","VT","VI","VA","WA","WV","WI","WY"];


	const [fnameerror,setFnameerror] = useState(false);
	const [addresserror,setAddressError] = useState(false);
    const [cityerror,setCityError] = useState(false);
	const [stateerror,setStateError] = useState(false);
	const [ziperror,setZipError] = useState(false);
	const [workphoneerror,setWorkPhoneError] = useState(false);
	const [emailerror,setEmailError] = useState(false);
	const [statuserror,setStatusError] = useState(false);

    const [city2Error,setCity2Error] = useState(false);
    const [add2Error,setAdd2Error] = useState(false);
    const [state2Error,setState2Error] = useState(false);

    const firstRender = useRef(true);
    const [disable, setDisabled] = useState(true);
    const [emailvaliderror, setEmailValidErrors] = useState(null);
    const [emailExistError, setEmailExistError] = useState(null);
    const [phonevalidError, setPhoneValidError] = useState(null);
    const [zipvalidError, setZipValidError] = useState(null);


    let arr = localStorage.getItem('association');

    let associationIds = arr.split(',');



    useEffect(() => {
        if (firstRender.current) {
          firstRender.current = false;
          return;
        }
    
    const formValidation = () => {
        const emailValidation = !/\S+@\S+\.\S+/.test(email);
          if (emailValidation) {
            setEmailValidErrors("Email address is invalid");
          } else {
            setEmailValidErrors(null);
          }
        };
       setDisabled(formValidation());

       

    //    const formPhoneValidation = () => {
    //       const phoneValidation =  /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(wphone);
    //       if (phoneValidation) {
    //         setPhoneValidError(null);
    //       } else {
    //         setPhoneValidError("Phone number is invalid");
    //       }
    //     };
    //     setDisabled(formPhoneValidation());

    //     const formZipValidation = () => {
    //         const zipValidation =  /^\d{6}(-\d{4})?$/.test(zip);
    //         if (zipValidation) {
    //           setZipValidError(null);
    //         } else {
    //             setZipValidError("Zip is invalid");
    //         }
    //       };
    //       setDisabled(formZipValidation());     



      }, [email]);


    let navigate = useNavigate();

    const { id } = useParams();

    const RoutetoList =()=> {

        let userrole = localStorage.getItem('userrole');


        if(userrole === 'SUPERADMIN'){
            navigate('/officials/'+id)
        }else{
            navigate("/association_officials/"+id)
        }
        

    }

    const onFormClick = () => {

        let error = 0;

		if(fname === '')
		{
			setFnameerror(true)
			error =1;
		}
		else
		{
			setFnameerror(false)
		}
        // if(address1 === '')
		// {
		// 	setAddressError(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setAddressError(false)
		// }
        if(city === '')
		{
			setCityError(true)
			error =1;
		}
		else
		{
			setCityError(false)
		}
        if(state === '')
		{
			setStateError(true)
			error =1;
		}
		else
		{
			setStateError(false)
		}
        // if(zip === '')
		// {
		// 	setZipError(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setZipError(false)
		// }
        if(email === '')
		{
			setEmailError(true)
			error =1;
		}
		else
		{
			setEmailError(false)
		}
        if(wphone === '')
		{
			setWorkPhoneError(true)
			error =1;
		}
		else
		{
			setWorkPhoneError(false)
		}
        if(city.length < 2){
            setCity2Error(true)
        }else{
            setCity2Error(false)
        }
        // if(address1.length < 2){
        //     setAdd2Error(true)
        // }else{
        //     setAdd2Error(false)
        // }
        if(state.length < 2){
            setState2Error(true)
        }else{
            setState2Error(false)
        }
        if(error === 0)
        {

            let token = "Bearer "+localStorage.getItem('token');
            //console.log(token)
            const data = {
                firstname :fname,
                lastname :lname,
                address_1:address1,
                address_2:address2,
                city:city,
                state:state,
                zip: zip,
                email:email,
                work_phone:wphone,
                // home_phone:hphone,
                association_id:id,
                status : 'ACTIVE'  
            }
            
            const instance = axios.create({

                baseURL: officials+"/association/"+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.post('',data).then((response) =>{

                //console.log('officials',response)
                
                let path = 'newPath'; 

                let userrole = localStorage.getItem('userrole');


                if(userrole === 'SUPERADMIN'){
                    navigate("/officials/"+id)
                }else{
                    navigate("/association_officials/"+id)
                }
                
            
            }).catch((error) =>{
                console.log('error',error.message)
                console.log(error.response.data.error[0].email)
                setEmailExistError(error.response.data.error[0].email)
                setZipValidError(error.response.data.error[0].zip)

            });

        }



    }

    const role = localStorage.getItem('userrole');


    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Add New Official</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            {
                              role === 'ASSOCIATION_USER' ? (
                                associationIds.length === 1?null:
                                <li className="breadcrumb-item"><Link to="/select_association">Home</Link></li>
                              ):
                                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            }
                            {
                              role === 'ASSOCIATION_USER' ?null :
                              (
                                <li className="breadcrumb-item"><Link to="/associations"> Association List</Link></li>
                              )
                            }
                            {role === 'ASSOCIATION_USER'?
                                <li className="breadcrumb-item"><Link to={"/association_officials/"+id}>Officials List</Link></li>:
                                <li className="breadcrumb-item"><Link to={"/officials/"+id}>Officials List</Link></li>
                            }
                            <li className="breadcrumb-item active" aria-current="page">Add Official</li>
                        </ol>
                    </nav>


                    <form className="needs-validation">
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >First Name<span style={{color: "red"}}>*</span></label>
                                            <input type="text" value={fname} onChange={e => {setFname(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter First Name" />
                                            {
                                                fnameerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter First Name</div>:null
                            			    }
                                        </div>
                                        <div className="col-md-6">
                                            <label >Last Name<span style={{color: "red"}}>*</span></label>		
                                            <input type="text" value={lname} onChange={e => {setLname(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Last Name" />
                                        </div>
                                    </div>
							    </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Address 1</label>
                                            <input type="text" value={address1} onChange={e => {setAddress1(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Address 1" />
                                            {/* {
                                                addresserror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Address</div>:null
                            			    }
                                            {
                                                add2Error
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Address must be more than 2 charactors.</div>:null
                            			    } */}
                                        </div>
                                        <div className="col-md-6">
                                            <label >Address 2</label>		
                                            <input type="text" value={address2} onChange={e => {setAddress2(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Address 2" />
                                        </div>
                                    </div>
							    </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >City<span style={{color: "red"}}>*</span></label>
                                            <input type="text" value={city} onChange={e => {setCity(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter City" />
                                            {
                                                cityerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter City</div>:null
                            			    }
                                            {
                                                city2Error
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>City must be more than 2 charactors.</div>:null
                            			    }
                                        </div>
                                        <div className="col-md-6">
                                            <label >State <span style={{color: "red"}}>*</span></label>	
                                            {/* <input type="text" value={state} onChange={e => {setState(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter State" /> */}

                                            <Dropdown title={state?state:"Select State"} className="state-dropdown"
                                             style={{ width:'100%', height:'10px'}}  >
                                                {statesData.map((item, index)=> (

                                                    <Fragment key={index}>
                                                        <Dropdown.Item value={item}
                                                            defaultChecked={state}
                                                            onClick={() => {{setState(item)}}}>
                                                                {item}
                                                        </Dropdown.Item>
                                                    </Fragment>
                                                ))}
                                            </Dropdown>


                                            {
                                                stateerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter State</div>:null
                            			    }
                                            {
                                                state2Error
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>State must be more than 2 charactors.</div>:null
                            			    }
                                        </div>
                                    </div>
							    </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Zip</label>
                                            <input type="number" value={zip} onChange={e => {setZip(e.target.value)}}
                                            
                                            className="form-control justshow bg-dark" placeholder="Enter Zip"  />
                                            {/* {
                                                ziperror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Zip</div>:
                                                <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{zipvalidError && <p>{zipvalidError}</p>}</div> 
                            			    } */}
                                        </div>
                                        <div className="col-md-6">
                                            <label >Email<span style={{color: "red"}}>*</span></label>		
                                            <input type="email" value={email} onChange={e => {setEmail(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Email" />
                                            {
                                                emailerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Email</div>
                                                : <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{emailvaliderror && <p>{emailvaliderror}</p>}</div>
                            			    }
                                            {
                                                emailExistError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{emailExistError && <p>{emailExistError}</p>}</div> :null
                            			    }

                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Best Contact Phone<span style={{color: "red"}}>*</span></label>
                                            <input type="text" value={wphone} onChange={e => {setWhone(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Best Contact Phone" />
                                            {
                                                workphoneerror
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Work Phone</div>
                                                :<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{phonevalidError && <p>{phonevalidError}</p>}</div>
                            			    }
                                        </div>
                                        {/* <div className="col-md-6">
                                            <label >Home Phone</label>		
                                            <input type="text" value={hphone} onChange={e => {setHphone(e.target.value)}} className="form-control justshow bg-dark" placeholder="Enter Home Phone" />
                                            
                                        </div> */}
                                    </div>
                                </div>

                                {/* <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                        <label >New/Previous</label>
                                        <div class="radio-btn-association">    
                                            <label>
                                                <input type="radio" onChange = { e => { setTypes(e.target.value);  } }  name="type" value="New" checked/><span className="new-previous-label">New</span>
                                            </label>
                                            <label>
                                                <input type="radio" onChange = { e => { setTypes(e.target.value);  } }  name="type" value="Previous"/><span className="new-previous-label">Previous</span>
                                            </label>
                                         </div>

                                        </div>
                                        <div className="col-md-6">
                                            
                                        </div>
                                    </div>
                                </div> */}

                                {/* <div className="form-group">
                                    <label className="degreehead">Status</label>
                                        <select  value={status} onChange={e => {setStatus(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                                <option value=''>Select Status</option>
                                                <option selected value="ACTIVE">ACTIVE</option>
                                                <option>INACTIVE</option>
                                                <option>DELETED</option>                                         
                                        </select>
                                        {
                                            statuserror
                                            ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Select Status</div>:null
                                        }
                                </div> */}

                                <div className="form-group text-right ">
							        <button className="btn btn-danger btn-gisa" onClick={RoutetoList} type="submit">Cancel</button>
								    <button onClick={ onFormClick } className="btn btn-primary btn-gisa" type="button">Create </button>
							    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </aside>
        </div>
    )
}

export default AddOfficials;
